import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { categoriesArrayPropTypes, userPropTypes } from 'helpers/propTypes';
import { logout } from 'redux/actions/user.actions';
import { openLoginModal, openRegisterModal, openSearchModal } from 'redux/actions/modal.actions';
import { cartSizeSelector } from 'redux/selectors/cart.selector';
import { favouriteSizeSelector } from 'redux/selectors/favourite.selector';

import Navbar from 'components/main/Header/Navbar';
import TopNav from 'components/main/Header/TopNav';

const HeaderContainer = (props) => {
  const {
    categories, cartSize, favouriteSize, logoutAction, openLoginModalAction,
    openRegisterModalAction, openSearchModalAction, user,
  } = props;
  const [isMenuActive, setIsMenuActive] = useState(false);
  const history = useHistory();
  const data = { oferta: true };

  const handleClick = () => {
    history.push('/productos', { data });
  };

  return (
    <header className="header trans-300">
      <TopNav
        logout={logoutAction}
        openLoginModal={openLoginModalAction}
        openRegisterModal={openRegisterModalAction}
        user={user}
      />
      <Navbar
        cartSize={cartSize}
        categories={categories}
        closeMenu={() => setIsMenuActive(false)}
        favouriteSize={favouriteSize}
        handleClick={handleClick}
        isMenuActive={isMenuActive}
        isUserLoggedIn={!!user}
        logout={logoutAction}
        openMenu={() => setIsMenuActive(true)}
        openLoginModal={openLoginModalAction}
        openRegisterModal={openRegisterModalAction}
        openSearchModal={openSearchModalAction}
        user={user}
      />
    </header>
  );
};

const mapStateToProps = (state) => ({
  cartSize: cartSizeSelector(state),
  categories: state.category.items,
  favouriteSize: favouriteSizeSelector(state),
  favourites: state.favourite.items,
  user: state.user.data,
});

const mapDispatchToProps = (dispatch) => ({
  logoutAction: bindActionCreators(logout, dispatch),
  openLoginModalAction: bindActionCreators(openLoginModal, dispatch),
  openRegisterModalAction: bindActionCreators(openRegisterModal, dispatch),
  openSearchModalAction: bindActionCreators(openSearchModal, dispatch),
});

HeaderContainer.defaultProps = {
  favouriteSize: 0,
  user: null,
};

HeaderContainer.propTypes = {
  cartSize: PropTypes.number.isRequired,
  categories: categoriesArrayPropTypes.isRequired,
  favouriteSize: PropTypes.number,
  logoutAction: PropTypes.func.isRequired,
  openLoginModalAction: PropTypes.func.isRequired,
  openRegisterModalAction: PropTypes.func.isRequired,
  openSearchModalAction: PropTypes.func.isRequired,
  user: userPropTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderContainer);
